import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-menu.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSMenuTriggerAnalyticsId;
(function (EGDSMenuTriggerAnalyticsId) {
  EGDSMenuTriggerAnalyticsId["EXPAND"] = "Expand";
  EGDSMenuTriggerAnalyticsId["COLLAPSE"] = "Collapse";
})(EGDSMenuTriggerAnalyticsId || (EGDSMenuTriggerAnalyticsId = {}));
class EGDSMenuTrigger extends React.Component {
  static displayName = 'EGDSMenuTrigger';
  static baseClassName = 'uitk-menu-trigger';
  render() {
    const {
      mounted,
      isOpen,
      children,
      menuId,
      onClick,
      disableLocalAnalytics
    } = this.props;
    const localAnalyticsId = isOpen ? EGDSMenuTriggerAnalyticsId.COLLAPSE : EGDSMenuTriggerAnalyticsId.EXPAND;
    const childCount = React.Children.count(children);
    if (!children || childCount !== 1) {
      console.warn(`UitkMenuTrigger requires exactly one child component. ${childCount} children found.`);
      return null;
    }
    const menuTriggerChild = children;
    const {
      className,
      analytics
    } = menuTriggerChild.props;
    const cssClassNames = getClassNameList(EGDSMenuTrigger.baseClassName, className);
    let additionalProps = {};
    if (!mounted) {
      const menuIdNoJs = menuId ? `-${menuId}` : '';
      additionalProps = {
        'aria-hidden': 'true',
        className: cssClassNames,
        htmlFor: `uitk-menu-no-js${menuIdNoJs}`,
        tag: 'label'
      };
      return React.cloneElement(menuTriggerChild, additionalProps);
    }
    additionalProps = {
      analytics: analytics && !disableLocalAnalytics ? {
        localAnalyticsId,
        ...analytics
      } : undefined,
      'aria-expanded': isOpen,
      className: cssClassNames,
      onClick: e => {
        if (onClick) {
          onClick(e, {
            menuId
          });
        }
        if (menuTriggerChild.props.onClick) {
          menuTriggerChild.props.onClick(e, {
            menuId
          });
        }
      }
    };
    return React.cloneElement(menuTriggerChild, additionalProps);
  }
}
export { EGDSMenuTrigger, EGDSMenuTriggerAnalyticsId };